module.exports = __webpack_public_path__ + "img/sub_page_communication20.475f9d99.png";